import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Row,
  Col,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Tooltip,
  Label,
  Input
} from 'reactstrap';
import Css from '@components/Quoting/Board/Passenger/Passenger.scss';
import DatePicker from 'react-datepicker/es';
import moment from 'moment';

class LegRow extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false
    };

    this.dateRef = React.createRef();
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  getAnimalInput = (amount, label, inputLabel) => {
    const returnArray = [];
    for (let i = 1; i <= amount; i++) {
      returnArray.push(
        <Col xs={4} key={label + i}>
          <FormGroup>
            <div>
              {i === 1 ? (
                <Label style={{ whiteSpace: 'nowrap' }}>{inputLabel}*</Label>
              ) : (
                <Label>&nbsp;</Label>
              )}
              <Input
                type={'number'}
                value={this.props[label + i].value}
                onChange={e =>
                  this.props.onInputChange(label + i, e.currentTarget.value)
                }
                placeholder={'#' + i}
                className={
                  this.props[label + i].visited &&
                  this.props[label + i].error !== false
                    ? 'is-invalid-input'
                    : ''
                }
              />
              {this.props[label + i].visited && (
                <span className={'error'}>{this.props[label + i].error}</span>
              )}
            </div>
          </FormGroup>
        </Col>
      );
    }

    return returnArray;
  };

  render() {
    const dogsWeight = this.getAnimalInput(
      this.props.dogsNo,
      'dogWeight',
      'Enter Weight for Each Dog (lbs)'
    );
    const catsWeight = this.getAnimalInput(
      this.props.catsNo,
      'catWeight',
      'Enter Weight for Each Cat (lbs)'
    );
    const aircraft = localStorage.getItem('selectedAircraft');

    return (
      <React.Fragment>
        {this.props.isMobile && <hr className={'mt-0 ' + Css.separator} />}
        <div
          className={
            'text-uppercase color-red font-sm lakes-bold mt-3 text-left'
          }
        >
          Leg {this.props.legNo}
        </div>
        <div
          className={
            this.props.isMobile
              ? 'background-white p-4 text-left ' + Css['member-content']
              : 'background-white p-4'
          }
        >
          {this.props.legNo > 1 && (
            <Row>
              <Col>
                <button
                  type={'button'}
                  className={'btn btn-red mb-3 btn-sm'}
                  onClick={this.props.copyPriorLeg}
                >
                  Copy information from prior leg
                </button>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={12} md={6}>
              <InputGroup className={'input-group-icon '}>
                <InputGroupAddon addonType="prepend">
                  # of Passengers
                </InputGroupAddon>

                <select
                  className={'form-control'}
                  value={this.props.passangerNo}
                  onChange={e =>
                    this.props.onPassengerNoChange(e.currentTarget.value)
                  }
                >
                  {(aircraft === 'E50P'
                    ? [1, 2, 3, 4, 5]
                    : [1, 2, 3, 4, 5, 6, 7, 8]
                  ).map(item => {
                    return (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </InputGroup>
            </Col>
          </Row>
          <div className={'color-dark-grey font-sm pt-2 pb-1'}>
            All passengers including infants must be listed.
          </div>

          {this.props.passengers.map((passenger, index) => {
            console.log(passenger.dob.value);
            return (
              <Row
                key={`passanger-${index}-${this.props.legNo}`}
                className={`passanger-${index}-${this.props.legNo}`}
              >
                <Col xs={12}>
                  <Label style={{ fontSize: '1rem' }}>
                    {index > 0 ? (
                      <React.Fragment>
                        Passenger {index + 1}
                        {((aircraft === 'E50P' && index === 4) ||
                          index === 7) && (
                          <span className={'color-red'}>
                            &nbsp;(Infant Only - Must Be Under the Age of 2)
                          </span>
                        )}
                        :
                      </React.Fragment>
                    ) : (
                      'Lead Passenger:'
                    )}
                  </Label>
                </Col>
                <Col xs={6} sm={3}>
                  <FormGroup>
                    <Label>First Name*</Label>
                    <Input
                      value={passenger.firstName.value}
                      className={
                        passenger.firstName.visited &&
                        passenger.firstName.error !== false
                          ? 'is-invalid-input'
                          : ''
                      }
                      onChange={e =>
                        this.props.onPassengerInputChange(
                          index,
                          'firstName',
                          e.currentTarget.value
                        )
                      }
                    />
                    {passenger.firstName.visited && (
                      <span className={'error'}>
                        {passenger.firstName.error}
                      </span>
                    )}
                  </FormGroup>
                </Col>
                <Col xs={6} sm={3}>
                  <FormGroup>
                    <div>
                      <Label>Last Name*</Label>
                      <Input
                        value={passenger.lastName.value}
                        className={
                          passenger.lastName.visited &&
                          passenger.lastName.error !== false
                            ? 'is-invalid-input'
                            : ''
                        }
                        onChange={e =>
                          this.props.onPassengerInputChange(
                            index,
                            'lastName',
                            e.currentTarget.value
                          )
                        }
                      />
                      {passenger.lastName.visited && (
                        <span className={'error'}>
                          {passenger.lastName.error}
                        </span>
                      )}
                    </div>
                  </FormGroup>
                </Col>
                <Col xs={6} sm={3}>
                  <FormGroup>
                    <div>
                      <Label>
                        Weight*{' '}
                        <small className={'color-dark-grey'}>(lbs)</small>
                      </Label>
                      <Input
                        type={'number'}
                        value={passenger.weight.value}
                        className={
                          passenger.weight.visited &&
                          passenger.weight.error !== false
                            ? 'is-invalid-input'
                            : ''
                        }
                        onChange={e =>
                          this.props.onPassengerInputChange(
                            index,
                            'weight',
                            e.currentTarget.value
                          )
                        }
                      />
                      {passenger.weight.visited && (
                        <span className={'error'}>
                          {passenger.weight.error}
                        </span>
                      )}
                    </div>
                  </FormGroup>
                </Col>
                <Col xs={6} sm={3}>
                  <FormGroup className={'mb-0'}>
                    <Label>DOB*</Label>
                  </FormGroup>
                  <InputGroup
                    className={
                      'input-group-icon ' +
                      (passenger.dob.visited && passenger.dob.error !== false
                        ? 'is-invalid'
                        : '')
                    }
                  >
                    <DatePicker
                      placeholderText={'MM/DD/YYYY'}
                      className={'form-control'}
                      onChange={date => {
                        this.props.onPassengerInputChange(
                          index,
                          'dob',
                          date !== null ? moment(date).format('MM/DD/YYYY') : ''
                        );
                      }}
                      selected={
                        passenger.dob.value === null ||
                        passenger.dob.value.length < 1
                          ? null
                          : new Date(passenger.dob.value)
                      }
                      ref={this.dateRef}
                      todayButton="Today"
                      popperPlacement={'bottom-end'}
                      readOnly={false}
                    />
                  </InputGroup>
                  {passenger.dob.visited && (
                    <span className={'error'}>{passenger.dob.error}</span>
                  )}
                </Col>
              </Row>
            );
          })}

          <hr />
          <Row>
            <Col xs={12}>
              <Label className={'color-red'} style={{ fontSize: '1rem' }}>
                More Passenger Information&nbsp;&nbsp;
                <span
                  id={`pettooltip${this.props.legNo}`}
                  className={'pointer'}
                >
                  <FontAwesomeIcon icon={['fas', 'info-circle']} />
                </span>
                <Tooltip
                  placement="right"
                  isOpen={this.state.tooltipOpen}
                  delay={0}
                  target={`pettooltip${this.props.legNo}`}
                  toggle={this.toggle}
                >
                  Pet Information
                </Tooltip>
              </Label>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <FormGroup>
                <Label># of Dogs</Label>
                <select
                  name={`dogs.${this.props.legNo}`}
                  value={this.props.dogsNo}
                  className={'form-control'}
                  onChange={e =>
                    this.props.onDropdownChange('dogsNo', e.currentTarget.value)
                  }
                >
                  <option value={0}>0</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                </select>
              </FormGroup>
            </Col>
            {dogsWeight}
          </Row>
          <Row>
            <Col sm={4}>
              <FormGroup>
                <Label># of Cats</Label>
                <select
                  name={`cats.${this.props.legNo}`}
                  value={this.props.catsNo}
                  className={'form-control'}
                  onChange={e =>
                    this.props.onDropdownChange('catsNo', e.currentTarget.value)
                  }
                >
                  <option value={0}>0</option>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                </select>
              </FormGroup>
            </Col>
            {catsWeight}
          </Row>
          <hr />
          <Row>
            <Col xs={12}>
              <Label className={'color-red'} style={{ fontSize: '1rem' }}>
                Total Luggage Weight
              </Label>
            </Col>
            <Col sm={12}>
              <FormGroup>
                <div>
                  <Label>Total Estimated Luggage Weight (lbs)*</Label>
                  <Row>
                    <Col sm={12} md={6}>
                      <Input
                        type={'number'}
                        value={this.props.totalLuggageWeight.value}
                        onChange={e =>
                          this.props.onInputChange(
                            'totalLuggageWeight',
                            e.currentTarget.value
                          )
                        }
                        className={
                          this.props.totalLuggageWeight.visited &&
                          this.props.totalLuggageWeight.error !== false
                            ? 'is-invalid-input'
                            : ''
                        }
                      />
                      {this.props.totalLuggageWeight.visited && (
                        <span className={'error'}>
                          {this.props.totalLuggageWeight.error}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default LegRow;



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/Passenger/LegRow/LegRow.jsx